import React, { Component } from 'react';
import { Row, Col, Nav, Card, CardGroup, ListGroup, Image, Tab, Container, Form, Button, Table } from 'react-bootstrap';
import SelectDropDown from '../../../neetjee_guru/components/selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import './_studentAdmission.scss';
import Camera from "./camera";
import axios, { post } from "axios";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter, Link } from "react-router-dom";
import * as Cookies from "es-cookie";
import moment from 'moment';

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const religions = [{ id: 1, name: "Hindu" }, { id: 2, name: "Muslim" }, { id: 3, name: "Christian" }, { id: 4, name: "Others" }]

const SUBMIT_ADMISSION_FORM = gql`
  mutation(
    $params:NewAdmissionStudent  
    ) {
        createNewAdmissionStudent(
        params: $params
     )
  }
`;


class StudentAdmissionHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultvalue: 0,
            loadingSpinner: 0,
            photo: "",
            camera: false,
            file: "",
            studentImagePreviewUrl: "",
            fatherImagePreviewUrl: "",
            motherImagePreviesUrl: "",
            guardian1ImagePreviesUrl: "",
            guardian2ImagePreviesUrl: "",
            form1: { firstName: "", exam: "", lastName: "", gender: 1, fatherName: "", fatherOccupation: "", branch: "", fatherMobile: "", motherName: "", motherOccupation: "", motherMobile: "", resident: 1, religion: "", nationality: "", idNo: "", address: "", city: "", state: "", zipCode: "", studentMobile: "", studentEmail: "", guardian1Name: "", guardian1Mobile: "", dob: "", guardian2Name: "", guardian2Mobile: "", admissionNumber: "" },
            form2: { SSCschoolName: "", SSCYear: "", SSCBoard: "", SSCGPA: "0.0", IntercollegeName: "", InterYear: "", InterBoard: "", InterGPA: "0.0", attempts: "0", totalNeetMarks: "0", botany_marks: "0", zoology_marks: "0", physics_marks: "0", chemistry_marks: "0", totalFee: 0, registrationFee: 0, concessionGiven: 0, committedFee: 0 },
            studentLogoFilePath: "",
            fatherLogoFilePath: "",
            motherLogoFilePath: "",
            guardian1LogoFilePath: "",
            guardian2LogoFilePath: "",
            cameraFileOpen: "",
            submitError: "",
            sucessMsg: "",
            firstnameError: "",
            lastnameError: "",
            dobError: "",
            fNameError: "",
            fMobileError: "",
            mNameError: "",
            addressError: "",
            cityError: "",
            stateError: "",
            zipCodeError: "",
            studentMobileError: "",
            studentEmailError: "",
            branchError: "",
            examError: "",
            getExams: []
        }
    }


    componentDidMount() {

        if (this.props.getIndividualAdmissionDetails.length > 0) {
            console.log("props", this.props);
            let individualData = this.props.getIndividualAdmissionDetails;
            let { form1, previousAcademices, form2 } = individualData[0];

            let genders = [{ id: 1, gender: "MALE" }, { id: 2, gender: "FEMALE" }, { id: 3, gender: "OTHER" }]
            let residents = [{ id: 1, resident: "Resident" }, { id: 2, resident: "Non Resident" }]



            let updateForm1 = {
                firstName: form1[0].student_first_name,
                lastName: form1[0].student_last_name,
                gender: (form1[0].gender != null && form1[0].gender != "") ? genders.filter((item) => item.gender == form1[0].gender)[0].id : 1,
                studentMobile: form1[0].student_mobile,
                studentEmail: form1[0].email,
                dob: form1[0].date_of_birth != ""
                    ? moment.unix(form1[0].date_of_birth).format("YYYY-MM-DD") : "",
                fatherName: form1[0].father_name,
                fatherOccupation: form1[0].father_occupation,
                fatherMobile: form1[0].father_contact_no,
                motherName: form1[0].mother_name,
                motherOccupation: form1[0].mother_occupation,
                motherMobile: form1[0].mother_contact_no,
                resident: (form1[0].residential_status != null && form1[0].residential_status != "") ? residents.filter((item) => item.resident == form1[0].residential_status)[0].id : 1,
                religion: (form1[0].religion != null && form1[0].religion != "") ? religions.filter((item) => item.name == form1[0].religion)[0].id : 1,
                nationality: form1[0].nationality,
                idNo: form1[0].other_identity,
                address: form1[0].address,
                city: form1[0].city,
                state: form1[0].state_id,
                zipCode: form1[0].pincode,
                guardian1Name: form1[0].guardian1_name,
                guardian1Mobile: form1[0].guardian1_number,
                guardian2Name: form1[0].guardian2_name,
                guardian2Mobile: form1[0].guardian2_number,
                admissionNumber: this.props.location.state.admission_no,
                branch: form1[0].branch_id,
                exam: form1[0].exam_id

            }

            let formSecond = {
                SSCschoolName: previousAcademices[0].college_name,
                SSCYear: previousAcademices[0].academic_year,
                SSCBoard: previousAcademices[0].board_name,
                SSCGPA: previousAcademices[0].gpa_percentage,
                IntercollegeName: previousAcademices[1].college_name,
                InterYear: previousAcademices[1].academic_year,
                InterBoard: previousAcademices[1].board_name,
                InterGPA: previousAcademices[1].gpa_percentage,
                attempts: form2.filter((item) => item.admission_form_field_id == 29)[0].value,
                totalNeetMarks: form2.filter((item) => item.admission_form_field_id == 28)[0].value,
                botany_marks: form2.filter((item) => item.admission_form_field_id == 30)[0].value,
                zoology_marks: form2.filter((item) => item.admission_form_field_id == 31)[0].value,
                physics_marks: form2.filter((item) => item.admission_form_field_id == 32)[0].value,
                chemistry_marks: form2.filter((item) => item.admission_form_field_id == 33)[0].value,
                totalFee: form2.filter((item) => item.admission_form_field_id == 23)[0].value,
                registrationFee: form2.filter((item) => item.admission_form_field_id == 24)[0].value,
                concessionGiven: form2.filter((item) => item.admission_form_field_id == 25)[0].value,
            }

            let studentLogoFilePath = form1[0].student_photo;
            let studentImagePreviewUrl = form1[0].student_photo != "" ? `https://rizee.in/educational_mngt/profile_photos/${form1[0].student_photo}` : "";

            let fatherLogoFilePath = form1[0].father_photo;
            let fatherImagePreviewUrl = form1[0].father_photo != "" ? `https://rizee.in/educational_mngt/profile_photos/${form1[0].father_photo}` : "";

            let motherLogoFilePath = form1[0].mother_photo;
            let motherImagePreviesUrl = form1[0].mother_photo != "" ? `https://rizee.in/educational_mngt/profile_photos/${form1[0].mother_photo}` : "";

            let guardian1LogoFilePath = form1[0].guardian1_photo;
            let guardian1ImagePreviesUrl = form1[0].guardian1_photo != "" ? `https://rizee.in/educational_mngt/profile_photos/${form1[0].guardian1_photo}` : "";


            let guardian2LogoFilePath = form1[0].guardian2_photo;
            let guardian2ImagePreviesUrl = form1[0].guardian2_photo != "" ? `https://rizee.in/educational_mngt/profile_photos/${form1[0].guardian2_photo}` : "";



            console.log("form111", updateForm1);

            this.setState({ form1: updateForm1, form2: formSecond, studentImagePreviewUrl, studentLogoFilePath, fatherLogoFilePath, fatherImagePreviewUrl, guardian2ImagePreviesUrl, motherImagePreviesUrl, motherLogoFilePath, guardian1LogoFilePath, guardian1ImagePreviesUrl, guardian2LogoFilePath });
            let e = {
                target: {
                    name: "branch",
                    value: form1[0].branch_id
                }
            }
            this.handleInputChange(e)

        }
    }

    handleFileChange = (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];
        let name = e.target.name;

        console.log("lllloading", file);

        // Here, you can perform further processing or send the image to a server for uploading
        reader.onloadend = async (e) => {
            let fobj = {
                stream: e.target.result,
                filename: file.name,
                mimetype: file.type,
            };
            console.log("base64", fobj.stream);

            const upload = await this.fileUpload(file, fobj.stream);

            let studentImagePreviewUrl = this.state.studentImagePreviewUrl;
            let fatherImagePreviewUrl = this.state.fatherImagePreviewUrl;
            let motherImagePreviesUrl = this.state.motherImagePreviesUrl;
            let guardian1ImagePreviesUrl = this.state.guardian1ImagePreviesUrl;
            let guardian2ImagePreviesUrl = this.state.guardian2ImagePreviesUrl;
            let studentLogoFilePath = this.state.studentLogoFilePath;
            let fatherLogoFilePath = this.state.fatherLogoFilePath;
            let motherLogoFilePath = this.state.motherLogoFilePath;
            let guardian1LogoFilePath = this.state.guardian1LogoFilePath;
            let guardian2LogoFilePath = this.state.guardian2LogoFilePath

            if (upload.data.result == "success") {
                if (name == "studentFileUpload") {
                    studentImagePreviewUrl = reader.result;
                    studentLogoFilePath = upload.data.filename
                } else if (name == "fatherFileUpload") {
                    fatherImagePreviewUrl = reader.result;
                    fatherLogoFilePath = upload.data.filename;
                } else if (name == "motherFileUpload") {
                    motherImagePreviesUrl = reader.result
                    motherLogoFilePath = upload.data.filename;
                } else if (name == "guardian1FileUpload") {
                    guardian1ImagePreviesUrl = reader.result
                    guardian1LogoFilePath = upload.data.filename;
                } else {
                    guardian2ImagePreviesUrl = reader.result
                    guardian2LogoFilePath = upload.data.filename;
                }

                this.setState({
                    file: file,
                    studentImagePreviewUrl,
                    fatherImagePreviewUrl,
                    motherImagePreviesUrl,
                    guardian1ImagePreviesUrl,
                    guardian2ImagePreviesUrl,
                    studentLogoFilePath,
                    fatherLogoFilePath,
                    motherLogoFilePath,
                    guardian1LogoFilePath,
                    guardian2LogoFilePath
                });

            }
        }
        reader.readAsDataURL(file)
    }



    parenthandleinputchange = async (e) => {
        let reader = new FileReader();

        let file = {
            lastModified: "1683974399048",
            name: "testing.jpeg",
            size: "99768",
            type: "image/jpeg",
            webkitRelativePath: "",
            filename: "testing.jpeg",
            mimetype: "image/jpeg",

        }

        let fobj = {
            stream: e,
            filename: "testing.jpeg",
            mimetype: "image/jpeg",
        };


        const upload = await this.fileUpload(file, fobj.stream);

        if (upload.data.result == "success") {

            if (this.state.cameraFileOpen == "studentFileUpload") {

                this.setState({
                    studentLogoFilePath: upload.data.filename,
                    studentImagePreviewUrl: e,
                });
            } else if (this.state.cameraFileOpen == "fatherFileUpload") {

                this.setState({
                    fatherLogoFilePath: upload.data.filename,
                    fatherImagePreviewUrl: e,
                });
            }
            else if (this.state.cameraFileOpen == "motherFileUpload") {

                this.setState({
                    motherLogoFilePath: upload.data.filename,
                    motherImagePreviesUrl: e,
                });
            } else if (this.state.cameraFileOpen == "guardian1FileUpload") {
                this.setState({
                    guardian1LogoFilePath: upload.data.filename,
                    guardian1ImagePreviesUrl: e,
                });
            } else {

                this.setState({
                    guardian2LogoFilePath: upload.data.filename,
                    guardian2ImagePreviesUrl: e,
                });
            }
        }
        reader.onloadend = async () => {
        }
    }

    handleInputChange = e => {
        console.log("component");
        const name = e.target.name;
        const value = e.target.value;
        let firstnameError = this.state.firstnameError;
        let lastnameError = this.state.lastnameError;
        let dobError = this.state.dobError;
        let fNameError = this.state.fNameError;
        let fMobileError = this.state.fMobileError;
        let mNameError = this.state.mNameError;
        let addressError = this.state.addressError;
        let cityError = this.state.cityError;
        let stateError = this.state.stateError;
        let zipCodeError = this.state.zipCodeError;
        let studentMobileError = this.state.studentMobileError;
        let studentEmailError = this.state.studentEmailError;
        let branchError = this.state.branchError;
        let examError = this.state.examError;



        if (name == "firstName") {
            firstnameError = ""
        } else if (name == "lastName") {
            lastnameError = ""
        } else if (name == "studentMobile") {
            studentMobileError = ""
        } else if (name == "studentEmail") {
            studentEmailError = ""
        } else if (name == "dob") {
            dobError = ""
        } else if (name == "fatherName") {
            fNameError = ""
        } else if (name == "fatherMobile") {
            fMobileError = ""
        } else if (name == "motherName") {
            mNameError = ""
        } else if (name == "address") {
            addressError = ""
        } else if (name == "city") {
            cityError = ""
        } else if (name == "state") {
            stateError = ""
        } else if (name == "zipCode") {
            zipCodeError = ""
        } else if (name == "branch") {
            branchError = ""
        } else if (name == "exam") {
            examError = ""
        }


        this.setState(prevState => {
            const newArray = prevState.form1;
            newArray[name] = value;
            return { form1: newArray, firstnameError, lastnameError, dobError, fNameError, fMobileError, mNameError, addressError, cityError, stateError, zipCodeError, studentMobileError, studentEmailError, branchError, examError, submitError: "", };
        });


        let getExams = [];


        if (name == "branch") {
            if (value != "0") {
                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getExams.push(newObj);
                })

                this.setState({
                    getExams: getExams,
                    // form1: { ...this.state.form1,exam: "" }
                })
            } else {
                this.setState({
                    getExams: [],
                    // form1: { ...this.state.form1,exam: "" }

                })
            }
        }
    };

    handleAcademicChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState(prevState => {
            const newArray = prevState.form2;
            newArray[name] = value;
            return { form2: newArray };
        });
    };




    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let usernameValid = this.state.usernameValid;
        let passwordValid = this.state.passwordValid;

        switch (fieldName) {
            case "username":
                var pattern = new RegExp(
                    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
                );

                if (value.length < 4) {
                    usernameValid = false;
                    fieldValidationErrors.username =
                        "Username cannot be less than 5 chars";
                }
                // else if (!pattern.test(value)) {
                //   usernameValid = false;
                //   fieldValidationErrors.username = "Invalid Username";
                // } 
                else {
                    usernameValid = true;
                    fieldValidationErrors.username = "";
                }

                break;
            case "password":
                if (value.length == "") {
                    passwordValid = false;
                    fieldValidationErrors.password = "Password cannot be Empty";
                } else {
                    passwordValid = true;
                    fieldValidationErrors.password = "";
                }

                break;

            default:
                break;
        }
        this.setState(
            {
                formErrors: fieldValidationErrors,
                usernameValid: usernameValid,
                passwordValid: passwordValid
            },
            this.validateForm
        );
    }

    onKeyPress = (event) => {
        let name = event.target.name;

        let maxLength = 9;
        if (name == "zipCode") {
            maxLength = 5
        } else if (name == "SSCYear" || name == "InterYear") {
            maxLength = 3
        } else if (name == "totalNeetMarks" || name == "botany_marks" || name == "zoology_marks" || name == "physics_marks" || name == "chemistry_marks") {
            maxLength = 2
        }
        let access = true;

        if (name == "botany_marks" || name == "zoology_marks" || name == "physics_marks" || name == "chemistry_marks") {
            console.log("event", event.target.value);
        }


        const keyCode = event.which || event.keyCode;
        const keyValue = String.fromCharCode(keyCode);


        if (!/^\d+$/.test(keyValue) || event.target.value.length > maxLength) {
            console.log("helllo");
            event.preventDefault();
        }
    }

    fileUpload(file, stream) {
        console.log("fileupload", file, stream);
        const url = "https://rizee.in/mobile1.php?uploadRegistraionImage=true";
        const formData = new FormData();
        formData.append("file", file);
        formData.append("stream", stream);
        const config = {
            headers: {
                "content-type": "application/x-www-form-urlencoded",
            },
        };

        return post(url, formData, config);
    }

    submitAdmission = () => {

        let { form1, form2, studentLogoFilePath, fatherLogoFilePath, motherLogoFilePath, guardian1LogoFilePath, guardian2LogoFilePath } = this.state;




        let resistriction = false;

        Object.entries(form1).map(([key, value]) => {
            console.log("key", key, value);


            if (key == "branch" && value == "") {
                this.setState({ branchError: "* Please select branch" });
                resistriction = true
            }

            if (key == "exam" && value == "") {
                this.setState({ examError: "* Please select exam" });
                resistriction = true
            }


            if (key == "firstName" && value == "") {
                this.setState({ firstnameError: "* Please enter the first name" });
                resistriction = true
            }


            if (key == "lastName" && value == "") {
                this.setState({ lastnameError: "* Please enter the last name" });
                resistriction = true
            }

            // if (key == "dob" && value == "") {
            //     this.setState({ dobError: "* Please select the  date of birth" });
            //     resistriction = true
            // }

            if (key == "fatherName" && value == "") {
                this.setState({ fNameError: "* Please enter the father name" });
                resistriction = true
            }

            if (key == "fatherMobile" && value == "") {
                this.setState({ fMobileError: "* Please enter the mobile number" });
                resistriction = true
            }

            if (key == "motherName" && value == "") {
                this.setState({ mNameError: "* Please enter the mother name" });
                resistriction = true
            }




            // if (key == "city" && value == "") {
            //     this.setState({ cityError: "* Please enter the city" });
            //     resistriction = true
            // }



            // if (key == "state" && value == "") {
            //     this.setState({ stateError: "* Please select State" });
            //     resistriction = true
            // }

            // if (key == "zipCode" && value == "") {
            //     this.setState({ zipCodeError: "* Please enter the pincode" });
            //     resistriction = true
            // }

            // if (key == "studentMobile" && value == "") {
            //     this.setState({ studentMobileError: "* Please enter the mobile number" });
            //     resistriction = true
            // }

            // if (key == "studentEmail" && value == "") {
            //     this.setState({ studentEmailError: "* Please enter the email" });
            //     resistriction = true
            // }

        });

        if (resistriction) {
            return ""
        }

        const firstForm = [{
            student_first_name: form1.firstName,
            student_last_name: form1.lastName,
            student_mobile: form1.studentMobile.toString(),
            date_of_birth: form1.dob != "" ? moment(form1.dob).unix().toString() : "",
            gender: parseInt(form1.gender),
            student_photo: studentLogoFilePath.toString(),
            admission_no: parseInt(form1.admissionNumber),
            father_name: form1.fatherName.toString(),
            father_photo: fatherLogoFilePath.toString(),
            father_occupation: form1.fatherOccupation.toString(),
            father_contact_no: form1.fatherMobile.toString(),
            mother_name: form1.motherName,
            mother_photo: motherLogoFilePath,
            mother_contact_no: form1.motherMobile,
            mother_occupation: form1.motherOccupation,
            residential_status: parseInt(form1.resident),
            religion: parseInt(form1.religion),
            nationality: form1.nationality.toString(),
            other_identity: form1.idNo.toString(),
            email: form1.studentEmail.toString(),
            address: form1.address.toString(),
            city: form1.city.toString(),
            pincode: form1.zipCode.toString(),
            state_id: parseInt(form1.state),
            guardian1_name: form1.guardian1Name.toString(),
            guardian1_number: form1.guardian1Mobile.toString(),
            guardian1_photo: guardian1LogoFilePath.toString(),
            guardian2_name: form1.guardian2Name.toString(),
            guardian2_number: form1.guardian2Mobile.toString(),
            guardian2_photo: guardian2LogoFilePath.toString(),
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(form1.branch),
            exam_id: parseInt(form1.exam),
            source: "web",
            inserted_by: 1,
        }]

        const previousAcademices = [
            { board_exam_id: 1, college_name: form2.SSCschoolName.toString(), academic_year: form2.SSCYear.toString(), gpa_percentage: parseFloat(form2.SSCGPA), board_name: form2.SSCBoard.toString() },
            { board_exam_id: 2, college_name: form2.IntercollegeName.toString(), academic_year: form2.InterYear.toString(), gpa_percentage: parseFloat(form2.InterGPA), board_name: form2.InterBoard.toString() }
        ]



        const secondForm = [{ admission_form_field_id: "28", value: form2.totalNeetMarks.toString() },
        { admission_form_field_id: "29", value: form2.attempts.toString() },
        { admission_form_field_id: "30", value: form2.botany_marks.toString() },
        { admission_form_field_id: "31", value: form2.zoology_marks.toString() },
        { admission_form_field_id: "32", value: form2.physics_marks.toString() },
        { admission_form_field_id: "33", value: form2.chemistry_marks.toString() },
        { admission_form_field_id: "24", value: form2.registrationFee.toString() },
        { admission_form_field_id: "25", value: form2.concessionGiven.toString() },
        { admission_form_field_id: "26", value: (form2.totalFee - form2.concessionGiven).toString() },
        { admission_form_field_id: "23", value: form2.totalFee.toString() }
        ];



        this.setState({
            loadingSpinner: 1,

        });


        let params = {
            form1: firstForm,
            previousAcademices: previousAcademices,
            form2: secondForm,
            student_admission_id: this.props.stateData.student_id
        };

        console.log("form1", params);


        this.submitAdmission1(
            params
        ).catch(error => {
            console.log("catch if error", error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loadingSpinner: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });

    }



    submitAdmission1 = async (params) => {

        console.log("params", params);
        await this.props.submitAdmissionForm({
            variables: {
                params
            },
            update: (store, { data }) => {
                console.log("data", data);

                if (data.createNewAdmissionStudent) {
                    this.setState({
                        sucessMsg: "Admission sumitted successfully"
                    })
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ loadingSpinner: 0, sucessMsg: "" });
        this.props.history.push({
            pathname: "/student-admission-list",
        });
    };






    render() {
        console.log("mahesh", this.props);
        let logo = this.props.getOrganisationProfile.logo;

        let isDisabled = false;
        let admissionDisabled = false;


        if (this.props.history.location.state != undefined && this.props.history.location.state.name == "view") {
            isDisabled = true;
        }

        if (this.props.history.location.state != undefined && (this.props.history.location.state.name == "view" || this.props.history.location.state.name == "edit")) {
            admissionDisabled = true;
        }

        return (
            <Container className='studentRegistration mt-4'>
                <Row>
                    <Col sm={12}>
                        <Card className='mt-3'>
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col lg={3} md={3} sm={12}>
                                            <Form.Group as={Col} >
                                                <Form.Control type="text" placeholder="Admission number" name='admissionNumber' onChange={this.handleInputChange} value={this.state.form1.admissionNumber} disabled={admissionDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={7} md={7} sm={12} className='logo'>
                                            <div className='text-right'>
                                                {logo != "" ? (
                                                    <Image src={`https://admin.rizee.in/files/${logo}`} height="80" style={{ width: 'auto', minWidth: 60 }} className='main_logo' />
                                                ) : ("")
                                                }
                                                <h6 className="color-light-blue mt-4  main_logo" >REGISTRATION FORM</h6>
                                            </div>
                                        </Col>
                                        <Col lg={5} md={5} sm={12} className='imageUpload'>
                                            <Row>
                                                <Col className='imagesize'>
                                                    {
                                                        this.state.studentImagePreviewUrl ? (
                                                            <Image src={`${this.state.studentImagePreviewUrl}`} style={{ width: '180px', height: "30vh" }} />

                                                        ) : (
                                                            <p className='samplePhoto'>Upload Image</p>
                                                        )
                                                    }
                                                </Col>
                                            </Row>

                                            {

                                                this.props.stateData.status == "view" ? ("") :
                                                    (
                                                        <Row>
                                                            <Col className='attatchmentBtn'>
                                                                <Button onClick={() => { this.setState({ camera: true, cameraFileOpen: "studentFileUpload" }) }} className='upload_btn float-'>Capture Image</Button>

                                                            </Col>
                                                            <Col>
                                                                <input type="file" id="file" className='fileInput' onChange={(e) => this.handleFileChange(e)} name="studentFileUpload" />
                                                                <label htmlFor='file' className='fileLabel'>Upload Image</label>
                                                            </Col>
                                                        </Row>
                                                    )
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={3} md={3} sm={12}>
                                            <Form.Group as={Col} controlId="formBranch">
                                                <Form.Label className='font-weight-bold'><span className="text-danger">* </span>Branch</Form.Label>
                                                <span className="text-danger ml-2">{this.state.branchError}</span>
                                                <Form.Control as="select" name="branch" onChange={this.handleInputChange} disabled={isDisabled} >
                                                    <option value={this.state.defaultvalue}>select Branch</option>
                                                    {this.props.globals.globalBranches.map(branchData => (
                                                        <option value={branchData.id} selected={this.state.form1.branch == branchData.id ? true : false}  >{branchData.branch_name}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>

                                        <Col lg={3} md={3} sm={12}>
                                            <Form.Group as={Col} controlId="formExam">
                                                <Form.Label className='font-weight-bold'><span className="text-danger">* </span>Exam</Form.Label>
                                                <span className="text-danger ml-2">{this.state.examError}</span>
                                                <Form.Control as="select" name="exam" onChange={this.handleInputChange} disabled={isDisabled} >
                                                    <option value={this.state.defaultvalue}>select Exam</option>
                                                    {this.state.getExams.map(examData => (
                                                        <option value={examData.value} selected={this.state.form1.exam == examData.value ? true : false}  >{examData.label}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridFirstName">
                                                <Form.Label className='font-weight-bold'><span className="text-danger">* </span>First Name</Form.Label>
                                                <span className="text-danger ml-2">{this.state.firstnameError}</span>
                                                <Form.Control type="text" placeholder="First Name" name='firstName' onChange={this.handleInputChange} value={this.state.form1.firstName} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridLastName">
                                                <Form.Label className='font-weight-bold'><span className="text-danger">* </span>Last Name</Form.Label>
                                                <span className="text-danger ml-2">{this.state.lastnameError}</span>
                                                <Form.Control type="text" placeholder="Last Name" name='lastName' onChange={this.handleInputChange} value={this.state.form1.lastName} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridStudentMobile">
                                                <Form.Label className='font-weight-bold'><span className="text-danger"></span>Mobile Number</Form.Label>
                                                <span className="text-danger ml-2">{this.state.studentMobileError}</span>
                                                <Form.Control type="text" placeholder="Phone Number" name='studentMobile' onChange={this.handleInputChange} value={this.state.form1.studentMobile} onKeyPress={this.onKeyPress} autoComplete="off" disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridStudentEmail">
                                                <Form.Label className='font-weight-bold'><span className="text-danger"></span>Email</Form.Label>
                                                <span className="text-danger ml-2">{this.state.studentEmailError}</span>
                                                <Form.Control type="email" placeholder="Email" name='studentEmail' onChange={this.handleInputChange} value={this.state.form1.studentEmail} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridRadioBtn">
                                                <Form.Label style={{ display: "block", fontWeight: "bold" }}><span className="text-danger">* </span>Gender</Form.Label>
                                                <Form.Check inline label="Male" name="gender" type="radio" id="gender1" value='1' onChange={this.handleInputChange}
                                                    checked={this.state.form1.gender == 1 ? true : false}
                                                    defaultChecked disabled={isDisabled} />
                                                <Form.Check inline label="Female" name="gender" type="radio" id="gender2" value='2' onChange={this.handleInputChange} checked={this.state.form1.gender == 2 ? true : false} disabled={isDisabled} />
                                                <Form.Check inline label="Others" name="gender" type="radio" id="gender3" value='3' onChange={this.handleInputChange} checked={this.state.form1.gender == 3 ? true : false} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>

                                        <Col lg={3} md={3} sm={12}>
                                            <Form.Group as={Col} controlId="formGridDOB">
                                                <Form.Label className='font-weight-bold'> <span className="text-danger"></span>Date of Birth</Form.Label>
                                                <span className="text-danger ml-2">{this.state.dobError}</span>
                                                <Form.Control type="date" name='dob' onChange={this.handleInputChange} value={this.state.form1.dob} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridFName">
                                                <Form.Label className='font-weight-bold'><span className="text-danger">* </span>Father's Name</Form.Label>
                                                <span className="text-danger ml-2">{this.state.fNameError}</span>
                                                <Form.Control type="text" placeholder="Father Name" name='fatherName' onChange={this.handleInputChange} value={this.state.form1.fatherName} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridFOccupation">
                                                <Form.Label className='font-weight-bold'>Occupation</Form.Label>
                                                <Form.Control type="text" placeholder="Occupation" name='fatherOccupation' onChange={this.handleInputChange} value={this.state.form1.fatherOccupation} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridFMobile">
                                                <Form.Label className='font-weight-bold'><span className="text-danger">* </span>Mobile Number</Form.Label>
                                                <span className="text-danger ml-2">{this.state.fMobileError}</span>
                                                <Form.Control type="text" placeholder="Mobile Number" name='fatherMobile' onChange={this.handleInputChange} onKeyPress={this.onKeyPress} autoComplete="off" value={this.state.form1.fatherMobile} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridMName">
                                                <Form.Label className='font-weight-bold'><span className="text-danger">*</span>Mother's Name</Form.Label>
                                                <span className="text-danger ml-2">{this.state.mNameError}</span>
                                                <Form.Control type="text" placeholder="Mother's Name" name='motherName' onChange={this.handleInputChange} value={this.state.form1.motherName} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridMOccupation">
                                                <Form.Label className='font-weight-bold'>Occupation</Form.Label>
                                                <Form.Control type="text" placeholder="Occupation" name='motherOccupation' onChange={this.handleInputChange} value={this.state.form1.motherOccupation} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridMMobile">
                                                <Form.Label className='font-weight-bold'>Mobile Number</Form.Label>
                                                <Form.Control type="text" placeholder="Mobile Number" name='motherMobile' onChange={this.handleInputChange} onKeyPress={this.onKeyPress} autoComplete="off" value={this.state.form1.motherMobile} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridResidentBtn">
                                                <Form.Label style={{ display: "block", fontWeight: "bold" }}>Residential Status</Form.Label>
                                                <Form.Check inline label="Resident" name="resident" type="radio" id="status1" defaultChecked value='1' onChange={this.handleInputChange} checked={this.state.form1.resident == 1 ? true : false} disabled={isDisabled} />
                                                <Form.Check inline label="Non Resident" name="resident" type="radio" id="status2" value='2' onChange={this.handleInputChange} checked={this.state.form1.resident == 2 ? true : false} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={3} md={3} sm={12}>
                                            <Form.Group as={Col} controlId="formGridReligion">
                                                <Form.Label className='font-weight-bold'>Religion</Form.Label>
                                                <Form.Control as="select" name="religion" onChange={this.handleInputChange} disabled={isDisabled} >
                                                    <option value="0">select Religion</option>
                                                    {religions.map(religion => (
                                                        <option value={religion.id} selected={this.state.form1.religion == religion.id ? true : false}  >{religion.name}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={3} md={3} sm={12}>
                                            <Form.Group as={Col} controlId="formGridNationality">
                                                <Form.Label className='font-weight-bold'>Nationality</Form.Label>
                                                <Form.Control type="text" placeholder="Nationality" name='nationality' onChange={this.handleInputChange} value={this.state.form1.nationality} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>

                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridOtherId">
                                                <Form.Label className='font-weight-bold'>Other ID Number</Form.Label>
                                                <Form.Control type="text" placeholder="Other ID Number" name='idNo' onChange={this.handleInputChange} value={this.state.form1.idNo} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridAddress">
                                                <Form.Label className='font-weight-bold'><span className="text-danger"></span>Address for Communication</Form.Label>
                                                <span className="text-danger ml-2">{this.state.addressError}</span>
                                                <Form.Control type="text" placeholder="Address" name='address' onChange={this.handleInputChange} value={this.state.form1.address} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={4} md={4} sm={12}>
                                            <Form.Group as={Col} controlId="formGridCity">
                                                <Form.Label className='font-weight-bold'><span className="text-danger"></span>City</Form.Label>
                                                <span className="text-danger ml-2">{this.state.cityError}</span>
                                                <Form.Control type="text" placeholder="city" name='city' onChange={this.handleInputChange} value={this.state.form1.city} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={4} md={4} sm={12}>
                                            <Form.Group as={Col} controlId="formGridState">
                                                <Form.Label className='font-weight-bold'><span className="text-danger"></span>State</Form.Label>
                                                <span className="text-danger ml-2">{this.state.stateError}</span>
                                                <Form.Control as="select" name="state" onChange={this.handleInputChange} disabled={isDisabled} >
                                                    <option value="0">select state</option>
                                                    {this.props.states.map(state => (
                                                        <option value={state.state_id} selected={this.state.form1.state == state.state_id ? true : false}  >{state.state_name}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={4} md={4} sm={12}>
                                            <Form.Group as={Col} controlId="formGridzipCode">
                                                <Form.Label className='font-weight-bold'><span className="text-danger"></span>Pincode</Form.Label>
                                                <span className="text-danger ml-2">{this.state.zipCodeError}</span>
                                                <Form.Control type="text" placeholder="Pincode" name='zipCode' onChange={this.handleInputChange} onKeyPress={this.onKeyPress} autoComplete="off" value={this.state.form1.zipCode} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridG1Name">
                                                <Form.Label className='font-weight-bold'>Guardian-1 Name</Form.Label>
                                                <Form.Control type="text" placeholder="Guardian-1  Name" name='guardian1Name' onChange={this.handleInputChange} autoComplete="off" value={this.state.form1.guardian1Name} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridG1Mobile">
                                                <Form.Label className='font-weight-bold'>Guardian-1 Mobile Number</Form.Label>
                                                <Form.Control type="text" placeholder="Guardian-1 Mobile Number" name='guardian1Mobile' onChange={this.handleInputChange} onKeyPress={this.onKeyPress} autoComplete="off" value={this.state.form1.guardian1Mobile} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridG2Name">
                                                <Form.Label className='font-weight-bold'>Guardian-2 Name</Form.Label>
                                                <Form.Control type="text" placeholder="Guardian-2  Name" name='guardian2Name' onChange={this.handleInputChange} autoComplete="off" value={this.state.form1.guardian2Name} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6} md={6} sm={12}>
                                            <Form.Group as={Col} controlId="formGridG2Mobile">
                                                <Form.Label className='font-weight-bold'>Guardian-2 Mobile Number</Form.Label>
                                                <Form.Control type="text" placeholder="Guardian-2 Mobile Number" name='guardian2Mobile' onChange={this.handleInputChange} onKeyPress={this.onKeyPress} autoComplete="off" value={this.state.form1.guardian2Mobile} disabled={isDisabled} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12}>
                                            <h4 className='mt-3' style={{ textAlign: "center" }}>CURRENT/PREVIOUS ACADEMIC DETAILS</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Table bordered>
                                                <thead className='tableHead'>
                                                    <tr>
                                                        <th>Exam</th>
                                                        <th>Name of School/College</th>
                                                        <th>Year</th>
                                                        <th>Board/University</th>
                                                        <th>GPA</th>
                                                    </tr>
                                                </thead>
                                                <tbody className='tableBody'>
                                                    <tr>
                                                        <td>SSC(10th)</td>
                                                        <td><input type='text' placeholder="School/College" name="SSCschoolName" onChange={this.handleAcademicChange} value={this.state.form2.SSCschoolName} disabled={isDisabled} /></td>
                                                        <td><input type='text' placeholder="Year" name="SSCYear" onChange={this.handleAcademicChange} value={this.state.form2.SSCYear} disabled={isDisabled} /></td>
                                                        <td><input type='text' placeholder="Board/University" name="SSCBoard" onChange={this.handleAcademicChange} value={this.state.form2.SSCBoard} disabled={isDisabled} /></td>
                                                        <td><input type='text' placeholder="GPA" name="SSCGPA" onChange={this.handleAcademicChange} value={this.state.form2.SSCGPA} disabled={isDisabled} /></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Intermediate(12th)</td>
                                                        <td><input type='text' placeholder="School/College" name="IntercollegeName" onChange={this.handleAcademicChange} value={this.state.form2.IntercollegeName} disabled={isDisabled} /></td>
                                                        <td><input type='text' placeholder="Year" name="InterYear" onChange={this.handleAcademicChange} value={this.state.form2.InterYear} disabled={isDisabled} /></td>
                                                        <td><input type='text' placeholder="Board/University" name="InterBoard" onChange={this.handleAcademicChange} value={this.state.form2.InterBoard} disabled={isDisabled} /></td>
                                                        <td><input type='text' placeholder="GPA" name="InterGPA" onChange={this.handleAcademicChange} value={this.state.form2.InterGPA} disabled={isDisabled} /></td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>Marks scored in NEET :<input type='text' placeholder="Score" name="totalNeetMarks" onChange={this.handleAcademicChange} onKeyPress={this.onKeyPress} value={this.state.form2.totalNeetMarks} disabled={isDisabled} /> / 720 </Col>
                                        <Col>
                                            <Form.Group as={Col} controlId="formGridRadioBtn">
                                                <Form.Label >NEET attempts :  </Form.Label>
                                                <Form.Check inline label="1" name="attempts" type="radio" id="attempts1" value='1' onChange={this.handleAcademicChange} checked={this.state.form2.attempts == 1 ? true : false} disabled={isDisabled} />
                                                <Form.Check inline label="2" name="attempts" type="radio" id="attempts2" value='2' onChange={this.handleAcademicChange} checked={this.state.form2.attempts == 2 ? true : false} disabled={isDisabled} />
                                                <Form.Check inline label="3" name="attempts" type="radio" id="attempts3" value='3' onChange={this.handleAcademicChange} checked={this.state.form2.attempts == 3 ? true : false} disabled={isDisabled} />
                                                <Form.Check inline label="4" name="attempts" type="radio" id="attempts4" value='4' onChange={this.handleAcademicChange} checked={this.state.form2.attempts == 4 ? true : false} disabled={isDisabled} />
                                            </Form.Group></Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} lg={3} md={3}>Botany = <input type='text' className='subMarksInput' name="botany_marks" onKeyPress={this.onKeyPress} onChange={this.handleAcademicChange} placeholder="Marks" value={this.state.form2.botany_marks} disabled={isDisabled} /> /180</Col>
                                        <Col sm={12} lg={3} md={3}>Zoology =  <input type='text' className='subMarksInput' name="zoology_marks" onKeyPress={this.onKeyPress} onChange={this.handleAcademicChange} placeholder="Marks" value={this.state.form2.zoology_marks} disabled={isDisabled} /> /180</Col>
                                        <Col sm={12} lg={3} md={3}>Physics = <input type='text' className='subMarksInput' name="physics_marks" onKeyPress={this.onKeyPress} onChange={this.handleAcademicChange} placeholder="Marks" value={this.state.form2.physics_marks} disabled={isDisabled} /> /180</Col>
                                        <Col sm={12} lg={3} md={3}>Chemistry =  <input type='text' className='subMarksInput' name="chemistry_marks" onKeyPress={this.onKeyPress} onChange={this.handleAcademicChange} placeholder="Marks" value={this.state.form2.chemistry_marks} disabled={isDisabled} /> /180</Col>
                                    </Row>

                                    <Row>
                                        <Col sm={12}>
                                            <h4 className='mt-3' style={{ textAlign: "center" }}>FEE DETAILS</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Table bordered>
                                                <thead className='tableHead'>
                                                    <tr>
                                                        <th>Total Fee</th>
                                                        <th>Registration Fee</th>
                                                        <th>Concession Given</th>
                                                        <th>Committed Fee</th>
                                                    </tr>
                                                </thead>
                                                <tbody className='tableBody'>
                                                    <tr>
                                                        <td><input type='text' name="totalFee" onChange={this.handleAcademicChange} value={this.state.form2.totalFee} disabled={isDisabled} /></td>
                                                        <td><input type='text' name="registrationFee" onChange={this.handleAcademicChange} onKeyPress={this.onKeyPress} value={this.state.form2.registrationFee} disabled={isDisabled} /></td>
                                                        <td><input type='text' name="concessionGiven" onChange={this.handleAcademicChange} value={this.state.form2.concessionGiven} disabled={isDisabled} /></td>
                                                        <td><input type='text' value={this.state.form2.totalFee - this.state.form2.concessionGiven} name="committedFee" disabled onChange={this.handleAcademicChange} /></td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12}>
                                            <h4 className='mt-3' style={{ textAlign: "center" }}>Image Upload</h4>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Table bordered>
                                                <thead className='tableHead'>
                                                    <tr>
                                                        <th>Father Image </th>
                                                        <th>Mother Image</th>
                                                        <th>Guardian-1 Image</th>
                                                        <th>Guardian-2 Image</th>
                                                    </tr>
                                                </thead>
                                                <tbody className='tableBody'>
                                                    <tr>
                                                        <td>
                                                            <Row>
                                                                <Col className='imageUpload'>
                                                                    <Row>
                                                                        <Col className='imagesize'>
                                                                            {
                                                                                this.state.fatherImagePreviewUrl ? (
                                                                                    <Image src={`${this.state.fatherImagePreviewUrl}`} style={{ width: '180px', height: "30vh" }} className='upload_btn' />

                                                                                ) : (
                                                                                    <p className='samplePhoto'>Upload Image</p>
                                                                                )
                                                                            }
                                                                        </Col>
                                                                    </Row>

                                                                    {

                                                                        this.props.stateData.status == "view" ? ("") :
                                                                            (
                                                                                <Row>
                                                                                    <Col className='attatchmentBtn'>
                                                                                        <Button onClick={() => { this.setState({ camera: true, cameraFileOpen: "fatherFileUpload" }) }} className='upload_btn'>Capture</Button>

                                                                                    </Col>
                                                                                    <Col>
                                                                                        <input type="file" id="fatherfile" className='fileInput' onChange={(e) => this.handleFileChange(e)} name="fatherFileUpload" />
                                                                                        <label htmlFor='fatherfile' className='fileLabel1 upload_btn'>Upload</label>
                                                                                    </Col>
                                                                                </Row>
                                                                            )
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </td>
                                                        <td>
                                                            <Row>
                                                                <Col className='imageUpload'>
                                                                    <Row>
                                                                        <Col className='imagesize'>
                                                                            {
                                                                                this.state.motherImagePreviesUrl ? (
                                                                                    <Image src={`${this.state.motherImagePreviesUrl}`} style={{ width: '180px', height: "30vh" }} className='upload_btn' />

                                                                                ) : (
                                                                                    <p className='samplePhoto'>Upload Image</p>
                                                                                )
                                                                            }
                                                                        </Col>
                                                                    </Row>

                                                                    {

                                                                        this.props.stateData.status == "view" ? ("") :
                                                                            (
                                                                                <Row>
                                                                                    <Col className='attatchmentBtn'>
                                                                                        <Button onClick={() => { this.setState({ camera: true, cameraFileOpen: "motherFileUpload" }) }} className='upload_btn'>Capture</Button>

                                                                                    </Col>
                                                                                    <Col>
                                                                                        <input type="file" id="motherfile" className='fileInput' onChange={(e) => this.handleFileChange(e)} name="motherFileUpload" />
                                                                                        <label htmlFor='motherfile' className='fileLabel1 upload_btn'>Upload</label>
                                                                                    </Col>
                                                                                </Row>
                                                                            )}
                                                                </Col>
                                                            </Row>
                                                        </td>
                                                        <td>
                                                            <Row>
                                                                <Col className='imageUpload'>
                                                                    <Row>
                                                                        <Col className='imagesize'>
                                                                            {
                                                                                this.state.guardian1ImagePreviesUrl ? (
                                                                                    <Image src={`${this.state.guardian1ImagePreviesUrl}`} style={{ width: '180px', height: "30vh" }} className='upload_btn' />

                                                                                ) : (
                                                                                    <p className='samplePhoto'>Upload Image</p>
                                                                                )
                                                                            }
                                                                        </Col>
                                                                    </Row>

                                                                    {

                                                                        this.props.stateData.status == "view" ? ("") :
                                                                            (
                                                                                <Row>
                                                                                    <Col className='attatchmentBtn'>
                                                                                        <Button onClick={() => { this.setState({ camera: true, cameraFileOpen: "guardian1FileUpload" }) }} className='upload_btn'>Capture</Button>

                                                                                    </Col>
                                                                                    <Col>
                                                                                        <input type="file" id="guardian1file" className='fileInput' onChange={(e) => this.handleFileChange(e)} name="guardian1FileUpload" />
                                                                                        <label htmlFor='guardian1file' className='fileLabel1 upload_btn'>Upload</label>
                                                                                    </Col>
                                                                                </Row>
                                                                            )}
                                                                </Col>
                                                            </Row>
                                                        </td>
                                                        <td>
                                                            <Row>
                                                                <Col className='imageUpload'>
                                                                    <Row>
                                                                        <Col className='imagesize'>
                                                                            {
                                                                                this.state.guardian2ImagePreviesUrl ? (
                                                                                    <Image src={`${this.state.guardian2ImagePreviesUrl}`} style={{ width: '180px', height: "30vh" }} className='upload_btn' />

                                                                                ) : (
                                                                                    <p className='samplePhoto'>Upload Image</p>
                                                                                )
                                                                            }
                                                                        </Col>
                                                                    </Row>

                                                                    {

                                                                        this.props.stateData.status == "view" ? ("") :
                                                                            (
                                                                                <Row>
                                                                                    <Col className='attatchmentBtn'>
                                                                                        <Button onClick={() => { this.setState({ camera: true, cameraFileOpen: "guardian2FileUpload" }) }} className='upload_btn'>Capture</Button>

                                                                                    </Col>
                                                                                    <Col>
                                                                                        <input type="file" id="guardian2file" className='fileInput' onChange={(e) => this.handleFileChange(e)} name="guardian2FileUpload" />
                                                                                        <label htmlFor='guardian2file' className='fileLabel1 upload_btn'>Upload</label>
                                                                                    </Col>
                                                                                </Row>
                                                                            )}
                                                                </Col>
                                                            </Row>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='text-center text-success'>{this.state.sucessMsg}</Col>
                                    </Row>

                                    <Row>
                                        <Col className='text-center text-danger'>{this.state.submitError}</Col>
                                    </Row>

                                    {

                                        this.props.stateData.status == "view" ? ("") :
                                            (
                                                <Row>
                                                    <Col lg={12} md={12} sm={12}>
                                                        <Button type="button"
                                                            className="btn text-uppercase  mt-2 submit_btn"
                                                            onClick={this.submitAdmission}>
                                                            {
                                                                this.state.loadingSpinner == 1 ?
                                                                    (<div class="spinner-border text-light  loading-img-center " style={{ display: "inline-block", width: "1rem", height: "1rem" }}></div>)
                                                                    :
                                                                    ("")
                                                            }
                                                            {
                                                                this.props.stateData.status != "" ? "Update" : "Submit"
                                                            }
                                                        </Button>
                                                    </Col>
                                                </Row>

                                            )

                                    }

                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Camera
                    show={this.state.camera}
                    parenthandleinputchange={this.parenthandleinputchange}
                    onHide={() => this.setState({ camera: false })}
                />
            </Container>
        )
    }
}

export default withRouter(compose(graphql(SUBMIT_ADMISSION_FORM, {
    name: "submitAdmissionForm"
})
)(StudentAdmissionHome));
